import { Typography, useTheme } from "@mui/material";
import React from "react";

import { Box } from "@/Components/v2/atoms/Box";
import { Breadcrumbs } from "@/Components/v2/atoms/Breadcrumbs";
import { Stack } from "@/Components/v2/atoms/Stack";
import { StatusEnum } from "@/pages/scenario-builder/types";

import ScenarioActionButtons from "./ScenarioActionButtons";

type NavigationBarProps = {
  scenarioId: string;
  scenarioName: string;
  scenarioDescription: string;
  scenarioStatus: StatusEnum;
  isActivityLogOpen: boolean;
  setIsActivityLogOpen: (open: boolean) => void;
  handleUpdateScenario: (updatedScenarioStatus: StatusEnum) => void;
};

const ScenarioApprovalsNavigationBar: React.FC<NavigationBarProps> = ({
  scenarioId,
  scenarioName,
  scenarioDescription,
  scenarioStatus,
  isActivityLogOpen,
  setIsActivityLogOpen,
  handleUpdateScenario,
}) => {
  const theme = useTheme();

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Breadcrumbs
          items={[
            {
              label: "All Scenarios",
              to: "/scenarios-v3/all",
            },
            {
              label: scenarioName,
            },
          ]}
        />
        <ScenarioActionButtons
          scenarioName={scenarioName}
          scenarioId={scenarioId}
          isActivityLogOpen={isActivityLogOpen}
          setIsActivityLogOpen={setIsActivityLogOpen}
          scenarioStatus={scenarioStatus}
          handleUpdateScenario={handleUpdateScenario}
        />
      </Stack>

      <Box
        sx={{
          maxWidth: "600px",
          paddingRight: "1rem",
          paddingBottom: "1.5rem",
        }}
      >
        <Stack
          direction="row"
          sx={{ width: "100%" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Stack justifyContent="start" alignItems="flex-start">
            <Typography
              id="modal-modal-title"
              marginBottom={0.5}
              marginLeft={0}
              fontWeight={600}
              fontSize={24}
              sx={{ color: theme.palette.tooltip.textColor }}
            >
              {scenarioName}
            </Typography>
          </Stack>
        </Stack>
        <Stack justifyContent="start" alignItems="flex-start">
          <Typography id="modal-modal-description" sx={{ color: theme.palette.tooltip.textColor }}>
            {scenarioDescription || ""}
          </Typography>
        </Stack>
      </Box>
    </>
  );
};

export default ScenarioApprovalsNavigationBar;
